export enum EPriceType {
	PRICE_LONG = 'priceLong',
	PRICE_SHORT = 'priceShort',
}

export interface IMoneyProps extends Intl.NumberFormatOptions {
	value?: number;
	currency: string;
	classNames?: string;
	showLocalizedPrices?: boolean;
	minimumFractionDigits?: number;
	priceType?: EPriceType;
	spaceBetweenCurrencyAndPrice?: boolean;
	locale?: string;
	options?: Intl.NumberFormatOptions;
}
